// Import Element UI components we'd like to use globally, our custom theme and locale information
import elementUi_cs from 'element-plus/lib/locale/lang/cs';
import elementUi_de from 'element-plus/lib/locale/lang/de';
import elementUi_en from 'element-plus/lib/locale/lang/en';
import elementUi_es from 'element-plus/lib/locale/lang/es';
import elementUi_fr from 'element-plus/lib/locale/lang/fr';
import elementUi_it from 'element-plus/lib/locale/lang/it';
import elementUi_ja from 'element-plus/lib/locale/lang/ja';
import elementUi_nl from 'element-plus/lib/locale/lang/nl';
import elementUi_pl from 'element-plus/lib/locale/lang/pl';
import elementUi_pt from 'element-plus/lib/locale/lang/pt';
import elementUi_ptbr from 'element-plus/lib/locale/lang/pt-br';
import elementUi_ro from 'element-plus/lib/locale/lang/ro';
import elementUi_sk from 'element-plus/lib/locale/lang/sk';

export const element = {
    'cs-CZ': elementUi_cs,
    'de-DE': elementUi_de,
    'en-GB': elementUi_en,
    'en-US': elementUi_en,
    'es-ES': elementUi_es,
    'fr-FR': elementUi_fr,
    'it-IT': elementUi_it,
    'ja-JP': elementUi_ja,
    'nl-NL': elementUi_nl,
    'pl-PL': elementUi_pl,
    'pt-BR': elementUi_ptbr,
    'pt-PT': elementUi_pt,
    'ro-RO': elementUi_ro,
    'sk-SK': elementUi_sk,
};
